<template>
	<div class="wish-card">
		<ul class="wish-maker">
			<li>
				<img :src="item.user.avatar" :alt="item.user.username">
			</li>
			<li>
				<a :href="`https://www.jeban.com/mypage/${item.user.id}`" target="_blank">{{ item.user.username }}</a>
			</li>
		</ul>
		<div class="content">
			<a v-if="showToggleButton && totalWish > 1" class="toggle-all-wish" @click="$emit('toggle')" v-html="`${totalWish} wishes`"></a>
			<h3>{{ item.detail }}</h3>
			<a class="cheer-up" @click="cheerUp" :class="{'-flash':flashCheer}">
				<span>{{ clapsDisplay }}</span>
				<span class="plus-one" v-if="debounceCheer" v-html="`+${debounceCheer}`"></span>
			</a>
		</div>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import debounce from '@/helpers'

	export default {
		props: {
			item: {
				type: Object,
				default: null
			},
			showToggleButton: {
				type: Boolean,
				default: false
			},
			totalWish: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
				cheer: 0,
				debounceCheer: 0,
				flashCheer: false
			}
		},
		computed: {
			clapsDisplay () {
				if (this.item.stat) {
					switch (true) {
						case this.item.stat.claps >= 1000000:
							return (`${(this.item.stat.claps / 1000000).toFixed(1)} k Cheer`).replace('.0', '')
							break
						case this.item.stat.claps >= 1000:
							return (`${(this.item.stat.claps / 1000).toFixed(1)} k Cheer`).replace('.0', '')
							break 
						default:
							return `${this.item.stat.claps} Cheer`
							break
					}					
				} else {
					return 'CHEER UP'
				}
			}
		},
		methods: {
			cheerUp () {
				this.cheer++
			}
		},
		watch: {
			cheer: debounce(function (newVal) {
				this.debounceCheer = newVal
			}, 1000),
			debounceCheer (newValue) {
				if (newValue) {
					this.flashCheer = true

					window.axios.post(
						`${config.BASE_URL}/wish/claps`,
						{
							wishId: this.item.id,
							claps: newValue
						}).then(response => {
							if (response.data.code === 0) {
								if (!this.item.stat) {
									this.item.stat = {
										claps : 0
									}
								}
								this.item.stat.claps = response.data.data.claps
							}
						})

					setTimeout(() => {
						this.flashCheer = false
						this.cheer = 0
					}, 1000)					
				}
			}
		}
	}
</script>

<style lang="scss">
	.wish-card {
		background: white;
		border-radius: 30px 0 30px 30px;

		display: flex;
		flex-flow: column;
		margin-bottom: 2rem;

		.wish-maker {
			padding: 0;
			margin: 0;
			margin-top: -8px;
			list-style-type: none;

			display: flex;
			flex-flow: row wrap;
			align-items: center;

			li {
				a {
					@include font-reg;
					font-size: 20px;
					color: #EEB85F;
					text-decoration: none;
				}

				&:last-child {
					flex: 1;
					padding-left: 5px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				img {
					width: 48px;
					height: 48px;
					border-radius: 50%;
					border: 4px solid white;
					box-sizing: border-box;

					box-shadow: 0px 2px 5px rgba(0, 0, 0, .16);
				}
			}
		}
		.content {
			padding: 0 1rem 1rem;
			flex: 1;

			h3 {
				@include font-reg;
				font-size: 28px;
				font-weight: normal;
				color: #93959A;
				line-height: 1;
				margin: .5rem 0 2rem;
			}
		}
		.toggle-all-wish {
			cursor: pointer;

			width: 80px;
			height: 28px;
			border-radius: 18px;
			border: 1px solid #EEB85F;
			background: rgba(238, 184, 95, .25);
			box-sizing: border-box;
			color: #EEB85F;
			display: flex;
			justify-content: center;
			align-items: center;

			@include font-li;
			font-size: 18px;
			margin: -.5rem auto 1.5rem;
		}
		.cheer-up {
			background: url('../assets/awesome-hand-peace.png') center center no-repeat;
		    background-position: right 5px bottom;
		    background-size: auto 28px;

			cursor: pointer;
			width: 113px;
			height: 35px;
			border-radius: 18px;
			border: 2px solid #EEB85F;
			box-sizing: border-box;
			color: #EEB85F;
			display: flex;
			justify-content: center;
			align-items: center;
			@include font-reg;
			font-size: 20px;
			margin: 0 auto;
			box-shadow: 0px 3px 10px rgba(0, 0, 0, .16);
			padding-right: 18px;
			user-select: none;
			position: relative;

			touch-action: manipulation;

			&:active {
				background-color: rgba(238, 184, 95, .25);
			}

			.plus-one {
				cursor: pointer;
				width: 32px;
				height: 32px;
				border-radius: 50%;
				@include font-cond;
				font-size: 20px;
				color: white;
				background: #EEB85F;
				position: absolute;
				top: 18px;
				left: 56px;
				display: flex;
				align-items: center;
				justify-content: center;

				transform: translate(-50%, -50%);
				opacity: 0;

				transition: all 100ms ease;
		    }

			&.-flash {
				.plus-one {
					opacity: 1 !important;
					transform: translate(-50%, -200%) !important;
				}
			}
		}
	}
</style>